"use strict";

class CorteExcepcionalController {
  constructor(NgTableParams, DataService, Message, Modal, $log, $scope) {
    "ngInject";
    //this.ValidationService = ValidationService;
    this.NgTableParams = NgTableParams;
    this.DataService = DataService;
    this.Message = Message;
    this.Modal = Modal;
    this.$log = $log;
    this.$scope = $scope;
    this.$scope.oneAtATime = true;
  }
  $onInit() {
    this.$log.log("Se esta iniciando la vista");
  }

  modalConfirmacion() {
    this.$log.log("Modal de confirmacion");
    this.Modal.confirm(
      "Se eliminaran los reportes actuales del corte del mes de noviembre ¿Esta seguro de habilitar el corte excepcional?",
      () => {
        this.$log.log("Confirmacion de corte excepcional");
        /* this.DataService.delete('usuario/' + user.id_usuario)
      .then(() => {
        this.Message.success('Su registro fue eliminado correctamente.');
        this.refresh();
      }); */
      }
    );
  }
}

export default CorteExcepcionalController;



// WEBPACK FOOTER //
// ./src/app/components/soporte/corteExcepcional/corteExcepcional.controller.js